module.exports = __webpack_public_path__ + "static/media/voltroph.9cece76e.webp";